/**
 * Client-side CSV export utility.
 * Escapes cells that contain commas, quotes, or newlines per RFC 4180.
 */
function escapeCell(v) {
  if (v == null) return "";
  const s = String(v);
  if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function exportToCsv(filename, rows, columns) {
  // columns: [{ key, label, transform? }]
  const header = columns.map((c) => escapeCell(c.label)).join(";");
  const body = rows
    .map((r) => columns.map((c) => escapeCell(c.transform ? c.transform(r) : r[c.key])).join(";"))
    .join("\n");
  const csv = "\ufeff" + header + "\n" + body; // BOM for Excel UTF-8
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
